import { Injectable } from "@angular/core";
import { ILoggedinPatientVM } from "../models/loggedin-patient";
import { ILoggedinUserVM } from "../models/loggedin-user";

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    private readonly key = 'access_token';

    getAccessToken = (): string | null => {
        return localStorage.getItem(this.key);
    }

    setAccessToken = (accessToken: string): void => {
        localStorage.setItem(this.key, accessToken);
    }

    getData = (): any | null => {
        return localStorage.getItem(this.key);
    }

    setData = (data: any): void => {
        localStorage.setItem(this.key, data);
    }

    setItem = (key: string, value: string): void => {
        localStorage.setItem(key, value);
    }

    getItem = (key: string): string | null => {
        return localStorage.getItem(key);
    }

    clearAll = (): void => {
        localStorage.clear();
    }

    isTokenExpired = (): boolean => {
        const user = this.getLoggedInUser();

        if (!user)
            return true;

        const expiry = user.exp || 0;
        const currentTime = (Math.floor((new Date).getTime() / 1000));

        return currentTime >= expiry;
    }

    getLoggedInUser = (): ILoggedinUserVM | null => {
        const token = this.getToken();

        if (!token)
            return null;

        const user = JSON.parse(atob(token)) || null;

        return user;
    }

    getLoggedinPatient = (): ILoggedinPatientVM | null => {
        const user = this.getLoggedInUser();

        if (!user)
            return null;

        return {
            patientId: Number((user && user?.ref_id || '0')),
            emailId: (user && user.email || 'NA'),
            fullName: (user && user.given_name || 'NA'),
        };
    }

    private getToken = (): string | null => {
        const accessToken = this.getAccessToken();

        if (!accessToken)
            return null;

        const token = accessToken.split('.')[1] || null;

        return token || null;
    }
}